import { render, staticRenderFns } from "./headerModal.vue?vue&type=template&id=04047673&scoped=true&"
import script from "./headerModal.vue?vue&type=script&lang=js&"
export * from "./headerModal.vue?vue&type=script&lang=js&"
import style0 from "./headerModal.vue?vue&type=style&index=0&id=04047673&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04047673",
  null
  
)

export default component.exports